import * as React from 'react';
import { Row } from 'react-bootstrap';

import type { CompanyViewModel } from 'ab-viewModels/company.viewModel';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

import CompanyFeatureFlagsEnum, { CompanyFeatureFlagsTips } from 'ab-enums/companyFeatureFlags.enum';

import PreviewItem from '../../Shared/PreviewItem';
import SettingPreview from '../../Shared/SettingPreview';

interface Props {
	toggleEdit: () => void;
	company: CompanyViewModel;
}

const TimeRoundingPreview: React.FC<Props> = (props) => {
	const { toggleEdit, company } = props;
	const { timeRoundingPolicyFrom } = company;

	return (
		<SettingPreview toggleEdit={toggleEdit}>
			<div className="company-settings__info-segment">
				<PreviewItem
					checked={!!timeRoundingPolicyFrom}
					hint={CompanyFeatureFlagsTips.startRoundingTimesTo1min}
					indent={false}
					label={CompanyFeatureFlagsEnum.startRoundingTimesTo1min}
					showCheckbox={true}
				/>
				{!!timeRoundingPolicyFrom &&
					<Row className="row--padded">
						<div>
							<strong>
								{TimeUtils.formatDate(timeRoundingPolicyFrom, TimeFormat.DATE_ONLY, TimeFormat.DB_DATE_ONLY)}
							</strong>
						</div>
					</Row>
				}
			</div>
		</SettingPreview>
	);
};

export default React.memo(TimeRoundingPreview);
